import script from "./LoadingBtn.vue?vue&type=script&lang=ts&setup=true"
export * from "./LoadingBtn.vue?vue&type=script&lang=ts&setup=true"

import "./LoadingBtn.vue?vue&type=style&index=0&id=707616e9&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-707616e9"]])

export default __exports__